<template>
  <div class="wrapper">
    <div class="formBox" v-if="hasPanel && isloaded">
      <div class="tabBox">
        <span :class="['tabText', activeTab ? 'activeTab' : '']" @click="activeTab = 1">邀请访客</span>
        <span :class="['tabText', activeTab ? '':'activeTab']" @click="activeTab = 0">拜访公司</span>
      </div>
      <div class="remarksBox">
        <span class="inviteText" v-if="activeTab">入驻企业员工邀请外部访客</span>
        <span class="visitText" v-else>外部访客预约拜访入驻公司</span>
      </div>
      <div class="form">
        <template v-for="item in regList">
          <div
            @click="searchPerson"
            class="nameBox"
            v-if="item.regKey === 'examine_user_name'"
            :key="item.regKey"
          >
            <div class="nameCardLeft">
              <span class="xin">*</span>
              <span class="label">{{item.regKey | labelFilter(activeTab)}}</span>
            </div>
            <div class="nameBoxRight" v-if="!userInfo">
              <span class="placeholder">请选择</span>
              <img class="yjt" src="../../assets/images/icon_indicator_next.png" />
            </div>
            <div class="nameCardRight" v-else>
              <div class="nameCardRightLeft">
                <span class="value">{{userInfo.userName}}</span>
                <div class="companyCard">
                  <span class="companyLabel">公司</span>
                  <span class="companyText">{{companyName}}</span>
                </div>
              </div>
              <img class="yjt" src="../../assets/images/icon_indicator_next.png" />
            </div>
          </div>
          <!-- 拜访公司 -->
          <div
            @click="searchCompanyName"
            class="nameBox"
            v-if="item.regKey === 'visitor_company' && (!hasPerson)"
            :key="item.regKey"
          >
            <div class="nameBoxLeft">
              <span class="xin">*</span>
              <span class="label">{{item.regKey | labelFilter(activeTab)}}</span>
            </div>
            <div class="nameBoxRight">
              <span class="placeholder" v-if="!companyName">请选择</span>
              <span class="value" v-else>{{companyName}}</span>
              <img class="yjt" src="../../assets/images/icon_indicator_next.png" />
            </div>
          </div>
          <!-- 拜访楼层 -->
          <div
            class="nameBox"
            v-if="item.regKey === 'visitor_floor' && item.regValue"
            @click="changeSelect(floorList,'visitor_floor')"
            :key="item.regKey"
          >
            <div class="nameBoxLeft">
              <span class="xin">*</span>
              <span class="label">{{item.regKey | labelFilter(activeTab)}}</span>
            </div>
            <div class="nameBoxRight">
              <span class="placeholder" v-if="!item.regValue">请选择{{item.regName}}</span>
              <span class="value" v-else>{{item.regValue}}</span>
              <img class="yjt" src="../../assets/images/icon_indicator_next.png" />
            </div>
          </div>
          <!-- 拜访日期 -->
          <div
            @click="pickTime"
            class="nameBox"
            v-if="item.regKey === 'visitor_date'"
            :key="item.regKey"
          >
            <div class="nameBoxLeft">
              <span class="xin">*</span>
              <span class="label">{{item.regKey | labelFilter(activeTab)}}</span>
            </div>
            <div class="nameBoxRight">
              <span class="placeholder" v-if="!item.regValue || item.regValue == 0">请选择</span>
              <span class="value" v-else>{{item.regValue}}</span>
              <img class="yjt" src="../../assets/images/icon_indicator_next.png" />
            </div>
          </div>
          <!-- 来访事由 -->
          <div
            @click="changeSelect(dictList,'visitor_type')"
            class="nameBox"
            v-if="item.regKey === 'visitor_type'"
            :key="item.regKey"
          >
            <div class="nameBoxLeft">
              <span class="xin">*</span>
              <span class="label">{{item.regKey | labelFilter(activeTab)}}</span>
            </div>
            <div class="nameBoxRight">
              <span class="placeholder" v-if="!item.regValue">请选择</span>
              <span class="value" v-else>{{item.regValue}}</span>
              <img class="yjt" src="../../assets/images/icon_indicator_next.png" />
            </div>
          </div>
          <!-- 证件类型 -->
          <div class="nameBox" v-if="item.regKey === 'visitor_id_type'" :key="item.regKey">
            <div
              class="nameBoxLeft borderRight"
              @click="changeSelect(idTypeList,'visitor_id_type')"
            >
              <span class="xin">*</span>
              <span class="label">{{item.regValue}}</span>
              <img class="yjt" src="../../assets/images/icon_indicator_next.png" />
            </div>
            <div class="nameBoxRight">
              <input class="input" type="text" placeholder="证件号码" @blur="blur" v-model.trim="visitorId" />
            </div>
          </div>
          <!-- 访客电话 -->
          <div class="nameBox" v-if="item.regKey === 'visitor_mobile'" :key="item.regKey">
            <div class="nameBoxLeft">
              <span class="xin">*</span>
              <span class="label">{{item.regKey | labelFilter(activeTab)}}</span>
            </div>
            <div class="nameBoxRight">
              <input
                class="input"
                type="tel"
                :placeholder="item.regName | place"
                v-model="item.regValue"
                 @blur="blur"
              />
            </div>
          </div>
          <!-- 访客人脸 -->
          <div class="faceBox" v-if="item.regKey === 'visitor_face_url'" :key="item.regKey">
            <div class="nameBoxLeft">
              <span class="xin"></span>
              <span class="label">访客人脸</span>
              <!-- <span class="label">{{item.regKey | labelFilter(activeTab)}}</span> -->
            </div>
            <div class="faceBoxRight">
               <div class="imageBg" >
                  <img @click="chooseImg" v-if="imageUrl" class="paiIcon" :src='imageUrl'/>
                  <img v-else @click="chooseImg" class="paiIcon" src='../../assets/images/icon_addphoen.jpg'/>
               </div>
            </div>
          </div>
          <!-- 其他  -->
          <div
            class="nameBox"
            v-if="item.regKey !== 'examine_user_name' && item.regKey !== 'visitor_floor' && item.regKey !== 'visitor_mobile' && item.regKey !== 'visitor_date'
            && item.regKey !== 'visitor_type' && item.regKey !== 'visitor_id_type' && item.regKey !== 'visitor_company' && item.regKey !=='visitor_face_url'
            && item.regKey !== 'visitor_id' && item.regKey !== 'visitor_arrive_wh' && item.regKey !== 'visitor_is_fever' && item.regKey !== 'visitor_is_mask'"
            :key="item.regKey"
          >
            <div class="nameBoxLeft">
              <span class="xin">*</span>
              <span class="label">{{item.regKey | labelFilter(activeTab)}}</span>
            </div>
            <div class="nameBoxRight">
              <input
                class="input"
                :type="item.regKey != 'visitor_num'?'text':'number'"
                :placeholder="item.regKey | labelFilter(activeTab) | place"
                v-model.trim="item.regValue"
                 @blur="blur"
              />
            </div>
          </div>
          <!-- 疫情 -->
          <div
            class="nameBox nameBox_flex"
            v-if="item.regKey == 'visitor_arrive_wh' || item.regKey == 'visitor_is_fever' || item.regKey == 'visitor_is_mask'"
            :key="item.regKey"
          >
            <div class="nameBoxLeft">
              <span class="xin">*</span>
              <span class="label">{{item.regName}}</span>
            </div>
            <div class="nameBoxRight">
              <yd-radio-group v-model="item.regValue" color="#1740da" style="line-height:20px;">
                <yd-radio val="是"></yd-radio>
                <yd-radio val="否"></yd-radio>
            </yd-radio-group>
            </div>
          </div>
        </template>
      </div>
      <p class="goHistory" @click="goHistory">查看历史记录</p>
    </div>
    <!-- 没有数据 -->
    <div class="no_mess" v-if="!hasPanel && isloaded">
      <p>{{common.marketInfo.marketName}}项目尚未配置</p>
      <p class="history_text" @click="goHistory">查看历史记录</p>
      <img src="../../assets/images/fangke.jpg" />
    </div>
    <mt-popup v-model="popupVisible" position="bottom" class="popupBox">
      <mt-picker
        class="picker"
        :slots="dataList"
        :visible-item-count="5"
        :show-toolbar="true"
        :item-height="44"
        ref="picker"
      >
        <div class="picker_wrap">
          <div class="picker_btn" @click="popupVisible=false">取消</div>
          <div class="picker_btn2" @click="handleConfirm">确认</div>
        </div>
      </mt-picker>
    </mt-popup>
    <yd-datetime
      style="display:none;"
      ref="datetime"
      @input="dateChange"
      type="datetime"
      v-model="date"
      start-date="1919-01-01"
    ></yd-datetime>
    <footer class="footer_box button" v-if="hasPanel && isloaded">
      <mt-button @click="insertVisitorReg" class="btn_default btn_primary">发起预约</mt-button>
    </footer>
  </div>
</template>

<script>
import util from "../../utils/util";
import storage from "../../utils/storage";
import { mapState, mapActions } from "vuex";
import { getVisitorRegByParams, insertVisitorReg ,serversHttp,uploadWapFace } from "../../utils/api";
import wx from 'weixin-js-sdk'
export default {
  name: "fanke",
  components: {},
  data() {
    return {
      regList: "",
      imageUrl:"",
      dictList: [],
      items: {},
      goNext: false,
      companyName: "",
      type: "",
      userInfo: "",
      Idtype: "",
      idTypeList: [],
      settingId: "",
      visitorId: "",
      hasPerson: false,
      companyInfo: "",
      activeTab: 1, //1邀请 //0拜访
      floorList: [],
      floorObjList: [],
      hasPanel: true,
      isloaded: false,
      dataList: [
        {
          flex: 1,
          values: [],
          className: "slot1",
          textAlign: "center"
        }
      ],
      selectType: "",
      popupVisible: false,
      date: util.formatTime(new Date(), 10)
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created() {
    this.getVisitorRegByParams();
  },
  activated() {
    const userInfo = storage.get("userInfo");
    if (userInfo) {
      this.userInfo = JSON.parse(userInfo);
      this.userInfoComputer();
    }
    const companyInfo = storage.get("companyInfo");
    if (companyInfo) {
      this.companyInfo = JSON.parse(companyInfo);
      this.companyComputer();
    }
  },
  methods: {
    blur(){
      setTimeout(function(){
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
      }, 100);
    },
    dateChange(val) {
      let regList = this.regList;
      for (var index in regList) {
        if (regList[index].regKey === "visitor_date") {
          regList[index].regValue = val;
        }
      }
      // this.cango()
    },
    handleConfirm() {
      this.popupVisible = false;
      let regList = this.regList;
      // 楼层
      if (this.selectType == "visitor_floor") {
        let val = this.$refs.picker.getValues()[0];
        for (var index in regList) {
          if (regList[index].regKey === "visitor_floor") {
            regList[index].regValue = val;
          }
        }
      } else if (this.selectType == "visitor_type") {
        // 拜访事由
        let val = this.$refs.picker.getValues()[0];
        for (var index in regList) {
          if (regList[index].regKey === "visitor_type") {
            regList[index].regValue = val;
          }
        }
      } else if (this.selectType == "visitor_id_type") {
        // 身份类型
        let val = this.$refs.picker.getValues()[0];
        for (var index in regList) {
          if (regList[index].regKey === "visitor_id_type") {
            regList[index].regValue = val;
          }
        }
      }
      // this.regList = regList;
      // console.log(this.regList)
      // this.cango()
    },
    searchPerson() {
      this.$router.push({
        path: `/searchPerson?activeTab=${this.activeTab}`
      });
    },
    goHistory() {
      this.$router.push({
        path: `/visitHistory?activeTab=${this.activeTab}`
      });
    },
    getVisitorRegByParams(comeClick) {
      getVisitorRegByParams({
        userId: this.common.userId,
        marketId: this.common.marketInfo.id
      }).then(res => {
        console.log(res);
        if (res.res.code === 10000) {
          this.floorObjList = [];
          this.regList = res.body.regList;
          this.settingId = res.body.setting.id;
          let regList = res.body.regList,
            idTypeList = res.body.idTypeList;
          for (let key in regList) {
            if (regList[key].regValue == 0) {
              regList[key].regValue = "";
            }
            if (regList[key].regKey === "examine_user_name") {
              this.hasPerson = true;
            }
            if (regList[key].regKey === "visitor_id_type") {
              regList[key].regValue = idTypeList[0].dictName;
            }
            // 如果是拜访公司,填充名字电话
            if (!this.activeTab) {
              if (regList[key].regKey === "visitor_user_name") {
                regList[key].regValue =
                  this.common.userTenantInfo.userName ||
                  this.common.userInfo.userName;
              }
              if (regList[key].regKey === "visitor_mobile") {
                regList[key].regValue =
                  this.common.userInfo.phone || this.common.userInfo.account;
              }
            }
          }
          if (res.body.dictList) {
            this.dictList = [];
            let dictList = res.body.dictList;
            for (let key in dictList) {
              this.dictList.push(dictList[key].dictName);
            }
          }
          if (res.body.idTypeList) {
            this.idTypeList = [];
            for (let key in idTypeList) {
              this.idTypeList.push(idTypeList[key].dictName);
            }
            this.Idtype = idTypeList[0].dictName;
          }
          if (this.activeTab) {
            if (res.body.examineInfo) {
              this.userInfo = res.body.examineInfo;
              this.userInfoComputer();
            } else if (res.body.companyInfo) {
              this.companyInfo = res.body.companyInfo;
              this.companyComputer();
            } else {
              this.activeTab = 0;
              // 如果是用户点击就显示提示
              if (comeClick) {
                util.showModal(
                  "",
                  "您在" + this.common.marketInfo.marketName + "尚未认证企业？",
                  true,
                  "去认证",
                  () => {
                    this.$router.push({
                      path: "/companyList"
                    });
                  }
                );
              }
            }
          }
        }else{
          this.hasPanel = false
        }
        util.hideLoading();
        //   this.cango()
        this.isloaded = true;
      });
    },
    pickTime() {
      this.$refs.datetime.open();
    },
    pickItem() {
      var params = {};
      params.options = this.dictList;
      normalPicker.openDialog(params, src => {
        this.type = src;
        let regList = this.regList;
        for (var index in regList) {
          if (regList[index].regKey === "visitor_type") {
            regList[index].regValue = src;
          }
        }
        this.regList = regList;
        //   this.cango()
      });
    },
    pickIdItem() {
      var params = {};
      params.options = this.idTypeList;
      normalPicker.openDialog(params, src => {
        this.Idtype = src;
        let regList = this.regList;
        for (var index in regList) {
          if (regList[index].regKey === "visitor_id_type") {
            regList[index].regValue = src;
          }
        }
        this.regList = regList;
        //   this.cango()
      });
    },
    getValue(e, key) {
      console.log(e);
      let regList = this.regList;
      for (var index in regList) {
        if (regList[index].regKey === key) {
          regList[index].regValue = e.value;
        }
      }
      this.regList = regList;
      // this.cango()
    },
    getVisitorId(e) {
      let regList = this.regList;
      for (var index in regList) {
        if (regList[index].regKey === "visitor_id") {
          regList[index].regValue = e.value;
        }
      }
      this.visitorId = e.value;
      this.regList = regList;
      // this.cango()
    },
    searchCompanyName() {
      this.$router.push({
        path: `/searchCompany?activeTab=${this.activeTab}`
      });
    },
    cango() {
      let regList = this.regList,
        goNext = true;
      for (var index in regList) {
        if (!regList[index].regValue || regList[index].regValue == 0) {
          goNext = false;
        }
      }

      this.goNext = goNext;
    },
    insertVisitorReg() {
      let regList = this.regList,
        params = {
          visitorMode: this.activeTab,
          userId: this.common.userId,
          userName: this.common.userInfo.userName,
          phone: this.common.userInfo.phone || this.common.userInfo.account,
          settingId: this.settingId,
          marketId: this.common.marketInfo.id,
          regList: regList
        };
      console.log(regList);
      if (this.userInfo !== "") {
        params.examineInfo = this.userInfo;
      }
      if (this.companyInfo !== "") {
        params.complaintInfo = this.companyInfo;
      }
      if (this.floorList.length !== 0) {
        for (var index in regList) {
          if (regList[index].regKey === "visitor_floor") {
            this.floorList.forEach((item, j) => {
              if (regList[index].regValue == item) {
                params.buildInfo = this.floorObjList[j];
              }
            });
          }
        }
      }
      let goNext = true,
        myreg = /^1\d{10}$/;
      for (var index in regList) {
        if (regList[index].regKey === "visitor_date") {
          if (!regList[index].regValue) {
            goNext = false;
            let text = this.activeTab ? "来访日期" : "拜访日期";
            util.showToast("请选择" + text);
            return;
          }
        } else if (regList[index].regKey === "visitor_mobile") {
          if (!myreg.test(regList[index].regValue)) {
            goNext = false;
            util.showToast("请输入正确的手机号");
            return;
          }
        } else if (regList[index].regKey === "visitor_id") {
          if (!this.visitorId) {
            goNext = false;
            util.showToast("请输入" + regList[index].regName);
            return;
          } else {
            regList[index].regValue = this.visitorId;
          }
        } else if (regList[index].regKey === "visitor_type") {
          if (!regList[index].regValue) {
            goNext = false;
            let text = this.activeTab ? "来访事由" : "拜访事由";
            util.showToast("请选择" + text);
            return;
          }
        } else if (regList[index].regKey == 'visitor_arrive_wh' || regList[index].regKey == 'visitor_is_fever' || regList[index].regKey == 'visitor_is_mask') {
          if (regList[index].regValue != '是' && regList[index].regValue != '否') {
            goNext = false;
            util.showToast("请选择" + regList[index].regName);
            return;
          }
        //访客人脸不校验
        } else if (regList[index].regKey === "visitor_face_url") {
            console.log("访客人脸不校验")
            if(this.imageUrl){
              regList[index].regValue =this.imageUrl
            }else{
              regList[index].regValue ="NO";
            }
        } else {
          if (!regList[index].regValue && regList[index].regKey != "visitor_floor") {
            goNext = false;
            if (regList[index].regName == "受访人姓名") {
              util.showToast("请选择受访人信息");
            } else {
              util.showToast("请输入" + regList[index].regName);
            }
            return;
          }
        }
      }
      if (!goNext) {
        return;
      }
      util.showLoading("提交中...");
      insertVisitorReg(params).then(res => {
        util.hideLoading();
        if (res.res.code === 10000) {
          this.userInfo = "";
          this.companyName = "";
          this.regList = "";
          this.date = util.formatTime(new Date(), 10);
          this.type = "";
          this.visitorId = "", this.idTypeList = [];
          this.getVisitorRegByParams();
          storage.remove("userInfo");
          storage.remove("companyInfo");
          this.$router.push({
            path: `/visitHistory?activeTab=${this.activeTab}`
          });
        }else if(res.res.code === 10003){
          util.showModal('',res.res.msg,false,'知道了')
        } else {
          util.showToast(res.res.msg);
        }
      });
    },
    changeSelect(data, type) {
      this.popupVisible = true;
      this.dataList[0].values = data;
      this.selectType = type;
    },
    userInfoComputer() {
      let regList = this.regList;
      for (var index in regList) {
        if (regList[index].regKey === "examine_user_name") {
          regList[index].regValue = this.userInfo.userName;
        }
        if (
          regList[index].regKey === "visitor_company" &&
          this.userInfo.company &&
          this.userInfo.company !== ""
        ) {
          this.companyName = this.userInfo.company;
          regList[index].regValue = this.userInfo.company;
        }
        if (regList[index].regKey === "visitor_floor" && this.userInfo.company) {
          this.floorObjList = this.userInfo.buildData || [];
          this.floorList = [];
          for (var i = 0; i < this.floorObjList.length; i++) {
            this.floorList.push(this.floorObjList[i].ld+'_'+this.floorObjList[i].lc);
          }
          console.log(this.floorObjList)
          regList[index].regValue = this.floorList[0] || '';
        }
      }
      this.regList = regList;
      // this.cango()
    },
    companyComputer() {
      let regList = this.regList;
      for (var index in regList) {
        if (regList[index].regKey === "visitor_company") {
          this.companyName = this.companyInfo.companyName;
          regList[index].regValue = this.companyInfo.companyName;
        }
        if (regList[index].regKey === "visitor_floor") {
          this.floorObjList = this.companyInfo.buildData || [];
          this.floorList = []; //地址,楼栋➕楼层
          for (var i = 0; i < this.floorObjList.length; i++) {
            this.floorList.push(this.floorObjList[i].dz);
          }
          regList[index].regValue = this.floorList[0] || '';
        }
      }
      this.regList = regList;
    },
    chooseImg(){
        console.log("in chooseImg")
        let that = this;
        wx.ready(()=>{
          wx.chooseImage({
            count: 1, // 默认9
            sizeType: ['original'], // 可以指定是原图还是压缩图，默认二者都有
            // sourceType: ['camera'], // 可以指定来源是相册还是相机，默认二者都有
            success: function (res) {
              console.log(res)
              wx.uploadImage({
                localId: res.localIds[0],
                isShowProgressTips: 1,
                success: function (ret) {
                  // 返回图片的服务器端ID
                  var serverId = ret.serverId;
                  that.uploadWapFace(serverId)
                }
              })
            },
            fail: function (res){
              alert(JSON.stringify(res))
            }
          })
        })
      },
    uploadWapFace(id){
      let params = {
        mediaId:id,
        marketId:this.common.marketInfo.id
      }
      util.showLoading();
      uploadWapFace(params).then(res=>{
        console.log(res)
        if(res.res && res.res.code === 10000 && res.body){
          util.hideLoading()
          if(res.body.isValid){
            this.imageUrl = res.body.imgUrl
          }else{
            util.showToast(res.body.errMsg)
          }
        }else{
          util.showToast('图片上传失败')
          util.hideLoading()
        }
      })
    },
  },
  filters: {
    place(value) {
      return "请输入" + value;
    },
    labelFilter: function(value, activeTab) {
      if (activeTab) {
        switch (value) {
          case "examine_user_name":
            return "我的信息";
            break;
          case "visitor_company":
            return "我的公司";
            break;
          case "visitor_floor":
            return "来访楼层";
            break;
          case "visitor_date":
            return "来访日期";
            break;
          case "visitor_user_name":
            return "访客姓名";
            break;
          case "visitor_mobile":
            return "访客电话";
            break;
          case "visitor_type":
            return "来访事由";
            break;
          case "visitor_num":
            return "来访人数";
            break;
          case "visitor_face_url":
            return "访客人脸";
            break;
          default:
        }
      } else {
        switch (value) {
          case "examine_user_name":
            return "受访人信息";
            break;
          case "visitor_company":
            return "拜访公司";
            break;
          case "visitor_floor":
            return "拜访楼层";
            break;
          case "visitor_date":
            return "拜访日期";
            break;
          case "visitor_user_name":
            return "访客姓名";
            break;
          case "visitor_mobile":
            return "访客电话";
            break;
          case "visitor_type":
            return "拜访事由";
            break;
          case "visitor_num":
            return "拜访人数";
            break;
          default:
        }
      }
    }
  },
  watch: {
    activeTab: function() {
      this.userInfo = "";
      this.companyName = "";
      this.regList = "";
      this.date = util.formatTime(new Date(), 10);
      this.type = "";
      this.visitorId = "", this.idTypeList = [];
      util.showLoading();
      this.getVisitorRegByParams("tabClick");
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.wrapper {
  background-color: @colore;
}
.formBox {
  width: 100%;
  margin-bottom: 130px;
}
//tabbox
.tabBox {
  width: 100%;
  height: 88px;
  .flex();
  justify-content: center;
  align-items: center;
  .tabText {
    display: block;
    height: 88px;
    line-height: 88px;
    font-size: 32px;
    color: @color9;
    flex: 1;
    text-align: center;
    position: relative;
    &:after {
      position: absolute;
      content: "";
      left: 50%;
      bottom: 0;
      width: 32px;
      height: 6px;
      margin-left: -16px;
      background: @colore;
    }
  }
  .activeTab {
    color: rgba(51, 51, 51, 1);
    &:after {
      background: @color17;
    }
  }
}
// remarksBox
.remarksBox {
  width: 100%;
  position: relative;
  padding: 20px 0 28px;
  height: 32px;
  span {
    position: absolute;
  }
  .inviteText {
    left: 25%;
    margin-left: -64px;
    font-size: 24px;
    color: #999;
    line-height: 32px;
  }
  .visitText {
    right: 25%;
    margin-right: -64px;
    font-size: 24px;
    color: rgba(153, 153, 153, 1);
    line-height: 32px;
  }
}
// form box
.form {
  margin: 0 20px;
  padding: 0 28px 0 20px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
  .border();
  overflow: hidden;
  .faceBox{
     min-height: 200px;
    .flex();
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .borderB();
    &:last-child {
      border: 0;
    }
  }
  .faceBoxRight {
    .flex();
    min-height: 200px;
    align-items: center;
    width: 436px;
    justify-content: space-between;
    .imageBg{
      margin-top:20px;
      width:200px;
      height:200px;
      padding:20px;
      // box-sizing:border-box;
      position:relative;
      // box-shadow:0px 4px 40px 0px rgba(0,91,165,0.29);
      // border-radius:8px;
      overflow:hidden;
      // background:#fff;
      // z-index:3;
    }
    .paiIcon{
        width:160px;
        height:160px;
    }
  }

  .nameBox {
    min-height: 100px;
    .flex();
    justify-content: space-between;
    align-items: center;
    width: 100%;
    .borderB();
    &:last-child {
      border: 0;
    }
  }
  .nameBox_flex{
    .nameBoxLeft{
      flex:1;
    }
    .nameBoxRight{
      width:auto;
    }
  }
  .nameCardLeft {
    width: 216px;
    min-height: 100px;
    .flex();
    // justify-content: space-between;
    align-items: center;
    .xin {
      color: #fc3f56;
      margin-right: 4px;
      display: block;
    }
    .label {
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
    }
  }
  .nameCardRight {
    flex: 1;
    // height: 144px;
    padding: 30px 0;
    margin-right: 10px;
    .flex();
    align-items: center;
    justify-content: space-between;
    .value {
      flex: 1;
      padding-right: 14px;
      text-overflow: ellipsis;
      white-space: nowrap;
      font-size: 28px;
      color: #000;
      display: block;
    }
  }
  .nameBoxLeft {
    width: 216px;
    min-height: 100px;
    .flex();
    align-items: center;
    .xin {
      color: #fc3f56;
      margin-right: 4px;
      display: block;
    }
    .label {
      font-size: 28px;
      color: rgba(51, 51, 51, 1);
    }
    > img {
      margin-left: 16px;
    }
  }
  .nameBoxRight {
    .flex();
    min-height: 100px;
    align-items: center;
    width: 436px;
    justify-content: space-between;
    .placeholder {
      font-size: 28px;
      color: rgba(201, 201, 201, 1);
    }
    .value {
      max-width: 400px;
      min-height: 100px;
      line-height: 100px;
      padding-right: 14px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      font-size: 28px;
      color: #000;
    }
  }
  .nameCardRightLeft {
    .flex();
    flex-direction: column;
    justify-content: space-between;
    flex: 1;
    .companyCard {
      .flex();
    }
    .companyLabel {
      font-size: 24px;
      color: rgba(153, 153, 153, 1);
      line-height: 34px;
      padding-right: 14px;
    }
    .companyText {
      font-size: 24px;
      color: rgba(51, 51, 51, 1);
      line-height: 34px;
      flex: 1;
    }
  }

  .borderRight {
    height: 100px;
    border-right-width: 1px;
    border-right-color: #eaeaea;
  }
}
.footer_box {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 108px;
  padding: 16px 28px;
  box-sizing: border-box;
  background: @colore;
  .btn_default {
    width: 100%;
    height: 76px;
    text-align: center;
    line-height: 76px;
    font-size: 32px;
    color: #fff;
    background: #dadada;
  }
  .btn_primary {
    background: @color17;
  }
}
.input {
  flex: 1;
  font-size: 28px;
  height: 98px;
  // line-height: 100px;
  /* padding-left: 14px; */
}

.yjt {
  width: 15px;
  height: 26px;
}

.goHistory {
  font-size: 26px;
  color: @color17;
  line-height: 32px;
  padding: 28px 0;
  padding-right: 20px;
  text-align: right;
}

.bottomButton {
  width: 100%;
  height: 108px;
  background-color: rgba(255, 255, 255, 1);
  justify-content: center;
  align-items: center;
}

.bottomButtonActive {
  width: 694px;
  height: 76px;
  background-color: rgba(0, 135, 255, 1);
  border-radius: 8px;
  font-size: 34px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 76px;
  text-align: center;
}

.cantGo {
  width: 694px;
  height: 76px;
  background-color: rgba(218, 218, 218, 1);
  border-radius: 8px;
  font-size: 34px;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  line-height: 76px;
  text-align: center;
}
.no_mess {
  text-align: center;
  p {
    height: 44px;
    font-size: 32px;
    color: rgba(153, 153, 153, 1);
    line-height: 44px;
    margin: 188px auto 60px;
  }
  .history_text {
    margin: 0;
    height: 32px;
    font-size: 28px;
    color: rgba(23, 64, 218, 1);
    line-height: 32px;
  }
  img {
    display: block;
    width: 100%;
    height: auto;
    margin-top: 300px;
    margin-bottom: 100px;
  }
}
</style>
